import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-484478e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "error-message"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { pluralize } from '@/lib/claimUtil';
import { useClaimStore } from '@/store/claimStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'MintingQuantityError',
  setup(__props) {

const store = useClaimStore();

return (_ctx: any,_cache: any) => {
  return (!_unref(store).canMint && (!_unref(store).hasAllowlist || (_unref(store).hasAllowlist && !_unref(store).isResetingMerkleData && _unref(store).mintForWallet)))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_unref(store).hasTokensToMint)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(store).hasntMintedAnyTokens
            ? 'Sorry, there are no items for you to claim.'
            : 'You\'ve claimed all your items.'), 1))
          : (_unref(store).isTryingToMintMoreTokensThanPossible)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "You can't claim more than " + _toDisplayString(`${_unref(store).maxNumberToMint} ${_unref(pluralize)(_unref(store).maxNumberToMint, 'item')}`), 1))
            : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})